import { required, minValue, maxValue } from 'react-admin';
import { ADS_JOB_WINDOW_MIN, ADS_JOB_WINDOW_MAX, ADS_JOB_RUN_AFTER_MAX, ADS_JOB_PRIORITY_MAX } from './adsJobsConstants';

export const windowDays = [required(), minValue(ADS_JOB_WINDOW_MIN), maxValue(ADS_JOB_WINDOW_MAX)];
export const priority = [required(), minValue(1), maxValue(ADS_JOB_PRIORITY_MAX)];
export const runAfterHour = [minValue(0), maxValue(ADS_JOB_RUN_AFTER_MAX)];
